import { Observable } from "rxjs";
import { DataClientErrorMessage } from "../error/error.service";
export class AbstractHttpService {
    /**
     * Handles an error returned from the request
     * @returns error DataClientErrorMessage ErrorObservable
     * @param response the http response
     * @param errorService Error Service
     */
    handleServiceError(response) {
        let errorMsg = new DataClientErrorMessage(response);
        return Observable.throw(errorMsg);
    }
}
//# sourceMappingURL=abstract-http.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/http/abstract-http.service.js
// module id = 43
// module chunks = 1